import React, { Suspense } from "react";
import { useSelector } from "react-redux";

import { attemptMethod } from "@utils/general";
import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { getFlyoutCategories } from "@redux/modules/value/flyoutCategories/flyoutCategories.selectors";
import * as HeaderModule from "@redux/modules/value/header/header.module";
import { getHeader } from "@redux/modules/value/header/header.selectors";
import { useGranite } from "@redux/modules/value/translations/translations.provider";
import { useThunkDispatch } from "@redux/dispatcher";

import Sidebar from "./sidebar.component";
import "./sidebar.scss";

type Props = {
    accountLinks: any;
    profilelink: string;
    innerHTML?: string;
};

const SidebarContainer = ({ accountLinks, profilelink, innerHTML }: Props) => {
    const { t } = useGranite();
    const flyoutCategories = useSelector(getFlyoutCategories);
    const header = useSelector(getHeader);
    const isClient = useIsClientSide();
    const dispatch = useThunkDispatch();

    const onUpdate = () => {
        dispatch(HeaderModule.update({ sidebarActive: !header?.sidebarActive }));
    };

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            <Sidebar
                data={flyoutCategories}
                active={isClient && !!header?.sidebarActive}
                profileLink={profilelink}
                accountLinks={attemptMethod(() => JSON.parse(accountLinks), [])}
                update={onUpdate}
                innerHTML={innerHTML}
            />
        </Suspense>
    );
};

export { SidebarContainer };
